import { useRef, useEffect, useState } from "react";
import styles from "./styles.module.css";
import { EVENTS } from "const";
import { eventsEmitter } from "utils/events";

const DropdownMenu = ({ button, items, direction = null }) => {
  const [open, setOpen] = useState(false);
  const [position, setPosition] = useState("bottom");
  const wrapperRef = useRef(null);
  const menuRef = useRef(null);
  const fileInputRef = useRef(null);

  const triggerFileUpload = () => {
    fileInputRef.current?.click();
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (!file) return;
    event.target.value = null;

    const uploadItem = items.find((i) => i.isFileInput);
    if (uploadItem?.onFileSelect) {
      uploadItem.onFileSelect(file);
    }
  };

  useEffect(() => {
    if (direction) {
      setPosition(direction);
      return;
    }
    if (open && wrapperRef.current && menuRef.current) {
      const wrapperRect = wrapperRef.current.getBoundingClientRect();
      const menuHeight = menuRef.current.offsetHeight;

      const spaceBelow = window.innerHeight - wrapperRect.bottom;
      const spaceAbove = wrapperRect.top;

      if (spaceBelow < menuHeight && spaceAbove > menuHeight) {
        setPosition("top");
      } else {
        setPosition("bottom");
      }
    }
  }, [open, direction]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    const unsubscribeFn = eventsEmitter.on(EVENTS.MOUSE_DOWN, handleClickOutside);
    return unsubscribeFn;
  }, []);

  return (
    <div className={styles.moreWrapper} ref={wrapperRef}>
      <div onClick={() => setOpen((prev) => !prev)}>{button}</div>

      {open && (
        <div ref={menuRef} className={`${styles.moreMenu} ${position === "top" ? styles.dropTop : styles.dropBottom}`}>
          {items.map((item, index) => (
            <div
              key={index}
              className={styles.menuItem}
              onClick={() => {
                if (item.isFileInput) {
                  triggerFileUpload();
                } else {
                  item.onClick();
                }
                setOpen(false);
              }}
            >
              <img src={item.icon} alt={item.label} />
              <h3>{item.label}</h3>
            </div>
          ))}
        </div>
      )}
      <input type="file" accept="text/csv" hidden ref={fileInputRef} onChange={handleFileChange} />
    </div>
  );
};

export default DropdownMenu;
